import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {newBathRoomModalSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {BathRoomModel} from '../../../bathrooms/models'
import {editBathRoomService} from '../../../bathrooms/services/editBathRoom.service'
import {getBathRoomByIdService} from '../../../bathrooms/services/getBathRoomById.service'
import {MasterModel} from '../../models'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bathRoomToEdit: BathRoomModel
  getBathRooms: () => void
}

const ModalUpdateBathRoom: FC<Props> = ({show, setShow, bathRoomToEdit, getBathRooms}) => {
  const handleClose = () => {
    setShow(false)
  }

  const [bathroomType, setBathRoomType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const {getMasterTable} = useCentralServices()

  useEffect(() => {
    getBathRoomData()
    getBathroomsTypeFn()
    getGenresFn()
  }, [])

  const getBathRoomData = async () => {
    const {
      data: {data},
    } = await getBathRoomByIdService(bathRoomToEdit.Id)
    const {Codigo, ModuloId, Observaciones, SexoId, TipoBanioId} = data
    setValue('Id', bathRoomToEdit.Id)
    // setValue('HabitacionId', currentTabItem.idToEdit as any)
    setValue('ModuloId', ModuloId)
    setValue('SexoId', SexoId)
    setValue('TipoBanioId', TipoBanioId)
    setValue('Codigo', Codigo)
    setValue('Observaciones', Observaciones)
  }

  const {
    register,
    setValue,
    handleSubmit,
    control,
    formState: {errors},
  } = useForm<BathRoomModel>({
    resolver: yupResolver(newBathRoomModalSchema),
  })

  const onSubmit = async (data: BathRoomModel) => {
    const {data: res} = await editBathRoomService(data)
    if (!res.error) {
      getSnackBarToast('Se actualizó con exito', 'success')
      handleClose()
      getBathRooms()
      //mostrar snackbar
    } else {
      getSnackBarToast(res.message, 'error')
    }
  }

  const getBathroomsTypeFn = async () => {
    const data = await getMasterTable('TipoBanio', true)
    setBathRoomType(data)
  }

  const getGenresFn = async () => {
    const data = await getMasterTable('Sexo', true)
    setGenre(data)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Baño</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='row'>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Tipo de Baño</label>
                  <Select
                    control={control}
                    name='TipoBanioId'
                    data={bathroomType}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Género</label>
                  <Select control={control} name='SexoId' data={genre} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Nomenclatura de Baño</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Codigo')}
                    />
                    <p>{errors.Codigo?.message}</p>
                  </div>
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Observaciones</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Observaciones')}
                    />
                    <p>{errors.Observaciones?.message}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateBathRoom}
